import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { Clipboard } from '@angular/cdk/clipboard';
import { MessageService } from 'primeng/api';

export interface EntityHeaderEntity {
  id: string | number;
  _id?: string;
  name: string;
  fileName?: string;
}

@Component({
  selector: 'app-entity-header',
  templateUrl: './entity-header.component.html',
})
export class EntityHeaderComponent {
  @Input() entity: EntityHeaderEntity;
  @Input() type: string;

  @Input() showDuplicateButtons: boolean = true;
  @Input() showCopyButton: boolean = false;

  @Output() onShowDupDialog = new EventEmitter<void>();
  @Output() onFetchLocalizedValues = new EventEmitter<void>();

  constructor(
    private router: Router,
    private clipboard: Clipboard,
    private messageService: MessageService,
  ) {}

  get editUrl(): string {
    return `/${this.type}/edit/${this.entity.id}`;
  }

  navigateToEdit(): void {
    this.router.navigate([this.editUrl]);
  }

  copyAssetInfo(): void {
    const name = this.entity.name || '';
    const id = this.entity.id || '';
    const fileName = this.entity.fileName || '';
    const text = `${name}, ID: ${id}, ${fileName}`;
    this.clipboard.copy(text);
    this.messageService.add({
      severity: 'success',
      summary: 'Copied',
      detail: text,
    });
  }

  showDupDialog(): void {
    this.onShowDupDialog.emit();
  }

  fetchLocalizedValues(): void {
    this.onFetchLocalizedValues.emit();
  }
}